import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Icon from "@material-ui/core/Icon";
import Tooltip from "@material-ui/core/Tooltip";
// core components
import HeaderLinks from "components/Header/HeaderLinks.jsx";

import manual from "./Back Office Manual.pdf";

import sidebarStyle from "assets/jss/material-dashboard-react/components/sidebarStyle.jsx";

const tooltips = {
  dashboard: ""
}

const Sidebar = ({ ...props }) => {
  // verifies if routeName is the one active (in browser input)
  function activeRoute(routeName) {
    return props.location.pathname.indexOf(routeName) > -1 ? true : false;
  }
  const { classes, color, logo, image, routes } = props;
  var links = (
    <List className={classes.list}>
      {routes.map((prop, key) => {
        if (prop.redirect) return null;
        var activePro = " ";
        var listItemClasses;
        listItemClasses = classNames({
          [" " + classes[color]]: activeRoute(prop.path),
        });

        const whiteFontClasses = classNames({
          [" " + classes.whiteFont]: activeRoute(prop.path),
        });

        // if (prop.sidebarName === "Alert Settings") {
        //   return (
        //     <Tooltip
        //       id="tooltip-top-start"
        //       title="This page is in development"
        //       placement="top-end"
        //       classes={{ tooltip: classes.tooltip }}
        //     >
        //       <NavLink
        //         to={false}
        //         className={activePro + classes.item}
        //         activeClassName="active"
        //       >
        //         <ListItem
        //           button
        //           className={classes.itemLink + listItemClasses}
        //           disabled
        //         >
        //           <ListItemIcon className={classes.itemIcon + whiteFontClasses}>
        //             {typeof prop.icon === "string" ? (
        //               <Icon>{prop.icon}</Icon>
        //             ) : (
        //               <prop.icon />
        //             )}
        //           </ListItemIcon>
        //           <ListItemText
        //             primary={prop.sidebarName}
        //             className={classes.itemText + whiteFontClasses}
        //             disableTypography={true}
        //           />
        //         </ListItem>
        //       </NavLink>
        //     </Tooltip>
        //   );
        // } else
        if (prop.sidebarName === "User Manual") {
          return (
            <Tooltip
              id="tooltip-top-start"
              title={prop.tooltip}
              placement="top-end"
              classes={{ tooltip: classes.tooltip }}
              key={key}
            >
              <NavLink
                to={manual}
                onClick={(event) => {
                  event.preventDefault();
                  window.open(manual);
                }}
                className={activePro + classes.item}
                activeClassName="active"
                key={key}
              >
                <ListItem button className={classes.itemLink + listItemClasses}>
                  <ListItemIcon className={classes.itemIcon + whiteFontClasses}>
                    {typeof prop.icon === "string" ? (
                      <Icon>{prop.icon}</Icon>
                    ) : (
                      <prop.icon />
                    )}
                  </ListItemIcon>
                  <ListItemText
                    primary={prop.sidebarName}
                    className={classes.itemText + whiteFontClasses}
                    disableTypography={true}
                  />
                </ListItem>
              </NavLink>
            </Tooltip>
          );
        }
        
        // Special styling for "Renew License" to make it stand out
        const isRenewLicense = prop.sidebarName === "Renew License";
        const renewLicenseClasses = isRenewLicense 
          ? classNames({
              [classes.itemLink]: true,
              [listItemClasses]: true,
            })
          : classes.itemLink + listItemClasses;
        
        return (
          <Tooltip
            id="tooltip-top-start"
            title={prop.tooltip}
            placement="top-end"
            classes={{ tooltip: classes.tooltip }}
            key={key}
          >
            <NavLink
              to={prop.path}
              className={activePro + classes.item}
              activeClassName="active"
              key={key}
            >
              <ListItem 
                button 
                className={renewLicenseClasses}
                style={isRenewLicense ? { 
                  backgroundColor: "rgba(255, 152, 0, 0.2)",
                  borderLeft: "3px solid #ff9800",
                  fontWeight: "bold"
                } : {}}
              >
                <ListItemIcon className={classes.itemIcon + whiteFontClasses}>
                  {typeof prop.icon === "string" ? (
                    <Icon>{prop.icon}</Icon>
                  ) : (
                    <prop.icon />
                  )}
                </ListItemIcon>
                <ListItemText
                  primary={prop.sidebarName}
                  className={classes.itemText + whiteFontClasses}
                  disableTypography={true}
                  style={isRenewLicense ? { fontWeight: "bold" } : {}}
                />
              </ListItem>
            </NavLink>
          </Tooltip>
        );
      })}
    </List>
  );
  var brand = (
    <div className={classes.logo}>
      <div className={classes.logoImage}>
        <img src={logo} alt="logo" className={classes.img} />
      </div>
    </div>
  );
  return (
    <div>
      <Hidden mdUp implementation="css">
        <Drawer
          variant="temporary"
          anchor="right"
          open={props.open}
          classes={{
            paper: classes.drawerPaper,
          }}
          onClose={props.handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>
            <HeaderLinks />
            {links}
          </div>
          {image !== undefined ? (
            <div
              className={classes.background}
              style={{ backgroundImage: "url(" + image + ")" }}
            />
          ) : null}
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        <Drawer
          anchor="left"
          variant="permanent"
          open
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          {brand}
          <div className={classes.sidebarWrapper}>{links}</div>
          {image !== undefined ? (
            <div
              className={classes.background}
              style={{ backgroundImage: "url(" + image + ")" }}
            />
          ) : null}
        </Drawer>
      </Hidden>
    </div>
  );
};

Sidebar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(sidebarStyle)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.jsx